import Vue from 'vue'
import Vuex from "vuex";


Vue.use(Vuex)
const store = new Vuex.Store({
   state:{
       type:'toman',
       usd:[],
       usdt:[],
       market:[],
       marketUSDT:[],
       marketType:'BITCOIN_TOMAN',
       info:{},
       notifs:'',   
       query:'',
    orders:[],
   },
    mutations:{
setQuery(state,query){
    state.query = query
},
changeOrderBooks(state,data){
    state.orders= data;
},
       changeType(state,type){
           if(type=='toman'){
               state.type='toman'
       }
           else{
               state.type='usdt'
           }
    },
    setNotifs(state,notifs){
        state.notifs = notifs
        
    },
        setUsd(state,usd){
            state.usd=usd
        },
        setUsdt(state,usdt){
            state.usdt=usdt
        },
        setTomanMarketInfo(state,market){
            state.market=market
        },
        setTetherMarketInfo(state,marketUSDT){
            state.marketUSDT=marketUSDT
        },
        setMarketType(state,marketType){
            state.marketType=marketType
        },
    },
    actions:{},
})




export default store